export const powerUnit = [
	'mW',
	'mW (eirp)',
	'W',
	'W (eirp)',
	'dBw',
	'dBm',
	'kW (eirp)',
	'ไม่มี',
]
